// //ganache-cli
/*
solana-test-validator --reset
solana-keygen new -o /solana/id.json
solana airdrop 10 <your wallet>
solana address
solana balance 3HVTE9MaZPUu3kmH5JrxVmmbUdhrqvt1w9mHfPKX733F
solana balance AkuadCTr8aDCwUVfevBxZudVehdDedVgW5LTGRgD7Eyi
*/


import React, { useState, useEffect, useContext, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setWalletId, setWallet, setDaysLeft, setIsPremium, setMembershipDate, setSymbolLimit, setPaymentType, setEthSnapshotPrice, setSolSnapshotPrice, setWebWalletApp, setEmail, setWalletErrorMsg, setIsAdmin } from '../pages/slices/globalDataSlicer';
import { ethers } from 'ethers';
import { CsrfTokenContext } from '../CsrfTokenContext';
import Confetti from 'react-confetti';
import './MetaMaskConnect.css';
import { Buffer } from 'buffer';
import { Link } from 'react-router-dom';
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';

window.Buffer = Buffer;
// import { Connection, PublicKey, clusterApiUrl } from '@solana/web3.js';

function isEthereumAddress(address) {
    // Check if it starts with '0x' and is 42 characters long
    return /^0x[a-fA-F0-9]{40}$/.test(address);
}

function isSolanaAddress(address) {
    // Check if it's base58 and typically between 44-48 characters long
    return /^[A-HJ-NP-Za-km-z1-9]{32,44}$/.test(address);
}

const MetaMaskConnect = () => {
    const [provider, setProvider] = useState(null);
    const [error, setError] = useState(null);
    const [isConnecting, setIsConnecting] = useState(false);
    const [receptionAdr, setReceptionAdr] = useState('');    
    const [showContext, setShowContext] = useState(false);
    const [showConfetti, setShowConfetti] = useState(false);
    const [solanaWalletPublicKey, setSolanaWalletPublicKey] = useState(null);

    const { wallet, blinkWallet, paymentType, ethSnapshotPrice, solSnapshotPrice, webWalletApp } = useSelector(state => state.globalData);
    // const { prices } = useSelector(state => state.streamCryptoInfo);  
    const dispatch = useDispatch();
    const csrfToken = useContext(CsrfTokenContext);

    const resetWalletState = useCallback(() => {
        dispatch(setWalletErrorMsg(''));
        dispatch(setWalletId(0));                    
        dispatch(setIsAdmin(false));                    
        dispatch(setDaysLeft(0));
        dispatch(setIsPremium(false));
        dispatch(setMembershipDate(null));
        dispatch(setSymbolLimit(11));
        dispatch(setPaymentType(''));
        dispatch(setEthSnapshotPrice(0.0));
        dispatch(setSolSnapshotPrice(0.0));
        dispatch(setWebWalletApp(''));
        dispatch(setEmail(''));  
        
        setProvider(null);
        setError(null);
        setIsConnecting(false);
        setReceptionAdr('');    
        setShowContext(false);
        setShowConfetti(false);
        setSolanaWalletPublicKey(null);
        dispatch(setWallet(null));

    }, [dispatch]);

    const refreshTokenIfNeeded = useCallback(async () => {
        if (isTokenExpired()) {        
          await handleLogin();
        }    
      },[]);

    const set_get_wallet = useCallback(async (wallet_member, isPayment, membership_type, payment_hash) => {
        try {

            await refreshTokenIfNeeded();
            
            if (webWalletApp === 'ethereum') {
                if(!ethers.utils.isAddress(wallet_member)){
                    throw new Error('Ethereum address not valid!');
                }            
            }

            if (webWalletApp === 'solana') {
                const publicKey = new window.solanaWeb3.PublicKey(wallet_member);
                if(!window.solanaWeb3.PublicKey.isOnCurve(publicKey)){
                    throw new Error('Solana address not valid!');
                }
            }

            const response = await fetch(`/api/set_get_Wallet?wallet=${wallet_member}&isPayment=${isPayment}&membership_type=${membership_type}&payment_hash=${payment_hash}`, {
                method: 'GET',
                headers: {                    
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                }
            });

            if (!response.ok) {              
                const errorData = await response.json();
                setError('Error on saving wallet');
                throw new Error(errorData.error);
            }

            const result = await response.json();
            const memberInfo = result[0] ? result[0] : result;

            if (isEthereumAddress(memberInfo.wallet)) {
                dispatch(setWebWalletApp('ethereum'));
            } else if (isSolanaAddress(memberInfo.wallet)) {
                dispatch(setWebWalletApp('solana'));
            } else {
                dispatch(setWebWalletApp(''));
            }

            console.log(memberInfo);

            dispatch(setWalletId(memberInfo.wallet_id));
            dispatch(setIsAdmin(memberInfo.isAdmin));
            dispatch(setWallet(memberInfo.wallet));
            dispatch(setDaysLeft(memberInfo.daysLeft));
            dispatch(setIsPremium(memberInfo.isMember));
            dispatch(setMembershipDate(memberInfo.membership_date));
            dispatch(setSymbolLimit(memberInfo.isMember ? 200 : 11));
            dispatch(setEmail(memberInfo.email));
            dispatch(setPaymentType(''));
            
        } catch (error) {
            console.error('Error fetching receptionAdr:', error);
        }
    }, [csrfToken, dispatch, refreshTokenIfNeeded, webWalletApp]);

    useEffect(() => {
        const fetchReceptionAdr = async () => {
            try {

                await refreshTokenIfNeeded();
                                
                const response = await fetch(`/api/getReceptionAdr?walletApp=${webWalletApp}`, {
                    method: 'GET',
                    // credentials: 'include',
                    headers: {                        
                        'Content-Type': 'application/json',
                        'X-CSRFToken': csrfToken
                    }
                });

                const result = await response.json();
                const adrRecept = result[0] ? result[0].address : result[0].address;                
                setReceptionAdr(adrRecept);                 
            } catch (error) {
                console.error('Error fetching receptionAdr:', error);
            }
        };

        if(webWalletApp !==''){
            fetchReceptionAdr();
        }

    }, [csrfToken, webWalletApp, refreshTokenIfNeeded ]);
    
    const connect = async () => {        
        if (wallet !== null) return;
        
        setShowContext(false);

        if (window.ethereum) { 
            const handleAccountsChanged = (accounts) => {                
                if (accounts.length > 0) {
                    set_get_wallet(accounts[0], false, '', '');
                } else {
                    resetWalletState();
                }
            };
            const handleDisconnect = () => {
                resetWalletState();
                setProvider(null);                
            };
            
            window.ethereum.on('accountsChanged', handleAccountsChanged);
            window.ethereum.on('disconnect', handleDisconnect);

            setIsConnecting(true);
            try {
                const tempProvider = new ethers.providers.Web3Provider(window.ethereum);
                await tempProvider.send('eth_requestAccounts', []);
                const accounts = await tempProvider.listAccounts();
                set_get_wallet(accounts[0], false, '', '');
                setProvider(tempProvider);
                setIsConnecting(false);                
                startMonitoring(receptionAdr);
                dispatch(setWebWalletApp('ethereum'));
            } catch (err) {                
                console.log('Error on connecting...');
                setIsConnecting(false);
            }

            return () => {
                if (window.ethereum.removeListener) {
                    window.ethereum.removeListener('accountsChanged', handleAccountsChanged);
                    window.ethereum.removeListener('disconnect', handleDisconnect);
                }
            };
        } else {
            setError('No wallet installed!');
        }
    };

    const monitorTransactions = useCallback((wallet) => {
        console.log('Monitoring transactions for account:', wallet);
        if (provider) {
            provider.on('pending', async (txHash) => {
                try {
                    const tx = await provider.getTransaction(txHash);
                    if (tx && tx.to === wallet) {
                        console.log('Incoming transaction:', tx);
                    }
                } catch (error) {
                    console.error('Error fetching transaction:', error);
                }
            });
        } else {
            console.error('Provider is not initialized');
        }
    }, [provider]);

    const startMonitoring = useCallback((wallet) => {
        if (wallet) {
            monitorTransactions(wallet);
        }
    }, [monitorTransactions]);

    const stopMonitoring = useCallback(() => {
        if (provider) {
            provider.removeAllListeners('pending');
        }
    }, [provider]);

    const disconnect = () => {
        resetWalletState();
        setProvider(null);
        stopMonitoring();
        setShowContext(false);
        setSolanaWalletPublicKey(null);
        dispatch(setWebWalletApp(''));
    };

    useEffect(()=>{

        // const sendPayment = async () => {
            
        //     if (!provider || !wallet || !receptionAdr) {
        //         dispatch(setPaymentType(''));
        //         setError('Provider, wallet, or reception address not set');
        //         return;
        //     }
    
        //     try {
        //         await window.ethereum.request({ method: 'eth_requestAccounts' });
        //         const signer = provider.getSigner();
        //         const tx = await signer.sendTransaction({
        //             to: receptionAdr,                    
        //             value: ethers.utils.parseEther(ethSnapshotPrice.toFixed(8)) // Example amount
        //         });
        //         console.log('Transaction sent:', tx);            
        //         set_get_wallet(wallet, true, paymentType, tx.hash);
                
        //         setTimeout(() => {
        //             dispatch(setPaymentType(''));
        //         }, 500);                

        //         // celebrateIt();
        //         localStorage.setItem('paymentConfirmed', 'true');
        //     } catch (err) {
        //         setError(`Failed to send transaction: ${err.message}`);
        //     }
        // };

        const sendPayment = async () => {
            if (!provider || !wallet || !receptionAdr) {
                dispatch(setPaymentType(''));
                setError('Provider, wallet, or reception address not set');
                return;
            }
        
            try {
                // Ensure MetaMask is connected and account is selected
                await window.ethereum.request({ method: 'eth_requestAccounts' });
        
                const signer = provider.getSigner();
                
                // Send transaction and let MetaMask handle any gas errors
                const tx = await signer.sendTransaction({
                    to: receptionAdr,
                    value: ethers.utils.parseEther(ethSnapshotPrice.toFixed(8)) // Transaction amount in ETH
                    // No gas specification here; MetaMask will handle it
                });
        
                console.log('Transaction sent:', tx);
        
                set_get_wallet(wallet, true, paymentType, tx.hash);
                
                setTimeout(() => {
                    dispatch(setPaymentType(''));
                }, 500);
        
                localStorage.setItem('paymentConfirmed', 'true');
            } catch (err) {
                if (err.message.includes('insufficient funds for gas')) {
                    setError('You have insufficient funds to cover the gas fees.');
                    dispatch(setWalletErrorMsg('You have insufficient funds to cover the gas fees.'));
                } else {
                    setError(`Failed to send transaction: ${err.message}`);
                }
            }
        };

        const sendPaymentAndConfirm = async () => {

            if (!solanaWalletPublicKey) {
                alert('Please connect to the Phantom wallet first.');
                return;
            }
    
            const enviroment = '';
            // const enviroment = 'dev';
    
            const connection = (new window.solanaWeb3.Connection(
                enviroment === 'dev' ? 'http://127.0.0.1:8899' : 'https://solana-mainnet.g.alchemy.com/v2/0xEPTSfxMl2dGGJQhtsePwNxHlxbtpK7',
                'confirmed'
            ));
            
            const recipientPublicKey = new window.solanaWeb3.PublicKey(receptionAdr);            
            // const recipientPublicKey = new window.solanaWeb3.PublicKey("3HVTE9MaZPUu3kmH5JrxVmmbUdhrqvt1w9mHfPKX733F");

            const amount = Math.round(solSnapshotPrice * 1e9).toString();
    
            try {
                // Fetch recent blockhash
                const { blockhash } = await connection.getLatestBlockhash();
    
                // Create and populate the transaction
                const transaction = new window.solanaWeb3.Transaction({
                    recentBlockhash: blockhash,
                    feePayer: solanaWalletPublicKey,
                }).add(
                    window.solanaWeb3.SystemProgram.transfer({
                    fromPubkey: solanaWalletPublicKey,
                    toPubkey: recipientPublicKey,
                    lamports: amount,
                    })
                );
    
                // Sign and send the transaction
                const { signature } = await window.solana.signAndSendTransaction(transaction);
                console.log('Transaction signed with signature:', signature);
    
                // Optionally, wait for a few seconds
                await new Promise(resolve => setTimeout(resolve, 2000)); 
                
                const confirmedTransaction = await connection.getTransaction(signature, { commitment: 'confirmed' });

                if (confirmedTransaction) {
                    const { meta } = confirmedTransaction;
                    if (meta && meta.err) {
                        console.error('Transaction failed:', meta.err);
                    } else {
                        console.log('Transaction was confirmed successfully.');
                        console.log('Transaction Hash:', signature);
                        set_get_wallet(wallet, true, paymentType, signature);                        
                        localStorage.setItem('paymentConfirmed', 'true');
                    }
                } else {
                    console.log('Transaction not confirmed or not found.');
                }
    
            } catch (error) {
                console.error('Transaction failed:', error);
                setError(error);
            }
        };
        
        if(webWalletApp === 'ethereum' && paymentType !== '' && ethSnapshotPrice > 0){ 
            sendPayment();
            dispatch(setPaymentType(''));
            dispatch(setEthSnapshotPrice(0.0));            
        }

        if(webWalletApp === 'solana' && paymentType !== '' && solSnapshotPrice > 0){ 
            sendPaymentAndConfirm();
            dispatch(setPaymentType(''));
            dispatch(setSolSnapshotPrice(0.0));
        }

    },[paymentType, provider, receptionAdr, set_get_wallet, wallet, dispatch, ethSnapshotPrice, solSnapshotPrice, solanaWalletPublicKey, webWalletApp])

    const celebrateIt = () => {
        setShowConfetti(true);
        setTimeout(() => {
          setShowConfetti(false); // Stop confetti after a few seconds
        }, 5000);
      };

    const disabledStyle = {
        cursor: 'not-allowed',
        pointerEvents: 'none',
        opacity: 0.5,
    };

    //  ******************************************************************************************
    //  ****************************************  SOLANA  ****************************************
    //  ******************************************************************************************
   
    
    // Custom Hook to dynamically load a script
    const useScript = (url) => {
        useEffect(() => {
            const script = document.createElement('script');
            script.src = url;
            script.async = true;
            document.body.appendChild(script);

            // Cleanup script when the component unmounts
            return () => {
                document.body.removeChild(script);
            };
        }, [url]);
    };

    // Use script hook here if needed
    useScript('https://unpkg.com/@solana/web3.js@latest/lib/index.iife.min.js'); // Example version

    const connectPhantomWallet = async () => {        
        setShowContext(false);        
        if (window.solana) {
            try {
                setIsConnecting(true);
                console.log('Connecting to wallet...');               
                const response = await window.solana.connect();                
                const publicKey = response.publicKey.toString();                
                set_get_wallet(publicKey, false, '', '');
                setSolanaWalletPublicKey(response.publicKey);
                dispatch(setWebWalletApp('solana'));
                setIsConnecting(false);
            } catch (error) {
                console.error('Error connecting to wallet:', error);
                setIsConnecting(false);
            }
        } else {
            setError('No wallet installed!');            
        }
    };  

    
    //  ********************************************************************************    
        
    useEffect(() => {
        // Function to check if confetti should be shown
        const checkConfetti = () => {
            if (localStorage.getItem('paymentConfirmed') === 'true') {
                // setShowConfetti(true);
                celebrateIt();

                localStorage.setItem('paymentConfirmed', 'false');

                // Clear the stored status after showing confetti
                localStorage.removeItem('paymentConfirmed');
            }
        };

        // Check confetti status when the component mounts
        checkConfetti();

        // Listen for visibility changes to trigger confetti when returning to the page
        const handleVisibilityChange = () => {
        if (document.visibilityState === 'visible') {
            checkConfetti();
        }
        };

        document.addEventListener('visibilitychange', handleVisibilityChange);

        return () => {
        document.removeEventListener('visibilitychange', handleVisibilityChange);
        };
    }, []);

    const imgIcon = () => {        
        if (webWalletApp === 'ethereum') {
          return '1027'; // Ethereum ID
        }
        if (webWalletApp === 'solana') {
          return '5426'; // Solana ID
        }
        return ''; // Default or fallback value (optional)
      };
   
    return (        
            <>
            {showConfetti && (
                <Confetti
                width={window.innerWidth}
                height={window.innerHeight}
                numberOfPieces={300}
                gravity={0.2}
                friction={0.98}
                initialVelocityX={0} // Start from the center horizontally
                initialVelocityY={20} // Falling downwards
                recycle={false}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: '50%',
                    transform: 'translateX(-50%)', // Center horizontally
                }}
            />
            )}
            <div
                style={{ position: 'relative', display: 'inline-block' }}
                onMouseEnter={() => setShowContext(error && error.includes('installed') ? false : true)}
                onMouseLeave={() => setShowContext(false)}
            >
                <span
                    disabled={isConnecting}
                    style={{
                        fontSize: '18pt',
                        cursor: 'pointer',
                        color: wallet ? '#65ff63' : 'gray'
                    }}
                >
                    <span style={{ fontSize: '18px', paddingRight: '10px', display:'flex', justifyContent:'center' }} >
                        <div style={{ display: 'flex', alignItems: 'center', paddingBottom: '5px' }} >
                            {wallet ? (
                            <>
                                <img 
                                src={`https://s2.coinmarketcap.com/static/img/coins/64x64/${imgIcon()}.png`}                                           
                                alt="Icon" 
                                style={{ marginRight: '8px', width: '25px', borderRadius: '50%' }} 
                                />
                                <span>{`${wallet.slice(0, 5)}...${wallet.slice(-5)}`}</span>
                            </>
                            ) : (
                            error ? (
                                <Link className={`${blinkWallet ? 'blinkW' : ''}`} style={{textDecoration:'none', color:'orange'}} to={error.includes('installed') ? '/Wallets' : ''}>{error}</Link>                             
                            ) : (
                                <span className={`${blinkWallet ? 'blinkW' : ''}`}> {(!wallet && isConnecting) ? 'Connecting...' : 'Connect Wallet'}</span>
                            )
                            )}
                            <i
                            style={{
                                paddingLeft: '10px',
                                fontSize: '15pt',
                                color: error && error.includes('installed') ? 'orange' : '',
                            }}
                            className={`bi bi-wallet2 ${blinkWallet ? 'blinkW' : ''}`}
                            />
                        </div>
                    </span>
                </span>
                <div className={`context-window ${showContext ? 'show' : ''}`}>
                    <div className={`button_metamask_container button-metamask`} style={wallet ? disabledStyle : {}} onClick={connect}>
                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/1027.png" alt="eth" style={{ marginRight: '10px', width: '30px', borderRadius: '50%' }} />
                        Ethereum
                    </div>
                    <div className={`button_metamask_container button-metamask`} style={wallet ? disabledStyle : {}} onClick={connectPhantomWallet}>
                        <img src="https://s2.coinmarketcap.com/static/img/coins/64x64/5426.png" alt="sol" style={{ marginRight: '10px', width: '30px', borderRadius: '50%' }} />
                        Solana
                    </div>
                    <br /><br />
                    <div className={`button_disc_container button`} style={!wallet ? disabledStyle : {}} onClick={disconnect}>
                        <i className="bi bi-escape" style={{ marginRight: '5px' }}></i>
                        Disconnect
                    </div>
                </div>
            </div></>
    );
};

export default MetaMaskConnect;
